/**
 * Standard async operation status enum
 * Use this for any asynchronous operations (API calls, data fetching, etc.)
 */
export enum AsyncStatus {
  Idle = "idle",
  Loading = "loading",
  Success = "success",
  Error = "error"
}

/**
 * Promise settlement status enum
 * Matches the status values from Promise.allSettled()
 */
export enum PromiseStatus {
  Fulfilled = "fulfilled",
  Rejected = "rejected"
}
